import {OddsViewModel} from "../../common/odds/models/odds.view-model";
import type {BetsLineDomainModel} from "./bets-line.domain-model";
import {observable, makeObservable} from 'mobx';

export class BetsLineViewModel extends OddsViewModel {
  lineId: String;
  internalOption: String;
  internalOptions: Array<Number>;
  internalOptionValue: String;
  isConcluded: Boolean;
  hasHistory: Boolean;
  @observable outcomeOptionNum: Number;

  constructor(domainModel: BetsLineDomainModel, oddsType: String) {
    super(domainModel, oddsType);

    this.internalOption = domainModel.internalOption;
    this.internalOptionValue = domainModel.internalOptionValue;
    this.isConcluded = domainModel.isConcluded;
    this.outcomeOptionNum = domainModel.outcomeOptionNum;
    this.lineId = domainModel.lineId;
    this.internalOptions = domainModel.internalOptions
    this.hasHistory = domainModel.hasHistory;

    makeObservable(this);
  }
}
